import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, Grid } from '@material-ui/core';
import { Card, Chip } from '@mui/material';
import { format } from 'date-fns';
import useStyles from './styles';
import { getInstanceRunningStatus } from '../../redux/Actions/clientInfo.action';
import InstanceName from '../../components/InstanceName';

const getBackground = (id) => {
    if (id === 'Operational') {
        return '#CBF4D3';
    }
    return '#FF8D00';
};

const getFontColor = (id) => {
    if (id === 'Operational') {
        return '#2C8F29';
    }
    return '#FFFFFF';
};

export default function Dashboard(props) {
    const classes = useStyles(props.theme);
    const dispatch = useDispatch();
    // to get logged in user info
    // const userInfo = useSelector((state) => state.userReducer.userInfo);
    const clientInfo = useSelector((state) => state.clientReducer.clientInfo);
    const runningStatus = useSelector((state) => state.clientReducer.instanceRunningStatus);
    useEffect(() => {
        dispatch(getInstanceRunningStatus(clientInfo.hostname));
    }, [clientInfo, dispatch]);
    return (
        <>
            <Card variant="outlined" className={classes.containerCard}>
                <div className={classes.instanceInfo}>
                    <Typography variant="h6" className={classes.instanceNameInfo}>
                        Instance Name
                    </Typography>
                    <InstanceName />
                    <Typography variant="h6" className={classes.instanceDateInfo}>
                        Last Update:{' '}
                        {clientInfo.updatedAt
                            ? format(new Date(clientInfo.updatedAt), 'yyyy-M-dd HH:mm:ss')
                            : '-'}
                    </Typography>
                </div>
                <Grid container spacing={3} className={classes.serviceContainer}>
                    {runningStatus.length > 0 &&
                        runningStatus.map((item) => (
                            <Grid
                                key={item._id}
                                item
                                xs={6}
                                sm={5}
                                md={4}
                                lg={3}
                                className={classes.overrideGrid}
                            >
                                <Card variant="outlined" className={classes.serviceCard}>
                                    <div className={classes.serviceCardContent}>
                                        <Typography
                                            variant="body1"
                                            className={classes.serviceCardTitle}
                                        >
                                            {item.name.replace('-', ' ')}
                                        </Typography>
                                        <Chip
                                            style={{
                                                backgroundColor: getBackground(item.status),
                                                color: getFontColor(item.status),
                                                fontWeight: '600'
                                            }}
                                            label={item.status}
                                            className={classes.serviceCardStatus}
                                        />
                                    </div>
                                </Card>
                            </Grid>
                        ))}
                </Grid>
            </Card>
            <Card variant="outlined" className={classes.containerCard}>
                <div className={classes.instanceInfo}>
                    <Typography variant="h6" className={classes.instanceDateInfo}>
                        Account Details
                    </Typography>
                </div>
                <Grid container spacing={3} className={classes.serviceContainer}>
                    <Grid
                        key="1"
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        className={classes.overrideGrid}
                    >
                        <Card variant="outlined" className={classes.accountCard}>
                            <div className={classes.serviceCardContent}>
                                <Typography variant="body1" className={classes.accountCardHeading}>
                                    Annual Support Package
                                </Typography>
                                <Typography variant="h5" className={classes.accountCardContent}>
                                    {clientInfo.annualSupportPackage}
                                </Typography>
                            </div>
                        </Card>
                    </Grid>
                    <Grid
                        key="2"
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        className={classes.overrideGrid}
                    >
                        <Card variant="outlined" className={classes.accountCard}>
                            <div className={classes.serviceCardContent}>
                                <Typography variant="body1" className={classes.accountCardHeading}>
                                    Subscription Start Date
                                </Typography>
                                <Typography variant="h5" className={classes.accountCardContent}>
                                    {clientInfo.subscriptionStartDate
                                        ? format(
                                              new Date(clientInfo.subscriptionStartDate),
                                              'MMMM dd, yyyy'
                                          )
                                        : '-'}
                                </Typography>
                            </div>
                        </Card>
                    </Grid>
                    <Grid
                        key="3"
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        className={classes.overrideGrid}
                    >
                        <Card variant="outlined" className={classes.accountCard}>
                            <div className={classes.serviceCardContent}>
                                <Typography variant="body1" className={classes.accountCardHeading}>
                                    Subscription End Date
                                </Typography>
                                <Typography variant="h5" className={classes.accountCardContent}>
                                    {clientInfo.subscriptionEndDate
                                        ? format(
                                              new Date(clientInfo.subscriptionEndDate),
                                              'MMMM dd, yyyy'
                                          )
                                        : '-'}
                                </Typography>
                            </div>
                        </Card>
                    </Grid>
                </Grid>
            </Card>
        </>
    );
}
